import { AutogenModelLocationLookup, AutogenRowLocationLookup } from "./autogen/AutogenModelLocationLookup";

export class ModelLocationLookup extends AutogenModelLocationLookup<RowLocationLookup> {
    constructor() {
        super(RowLocationLookup);
    }
}

export class RowLocationLookup extends AutogenRowLocationLookup {
}